<template>
    <div>
        <Header class="header">
            <Menu class="header-menu" mode="horizontal" theme="dark">
                <div class="layout-logo"></div>
                <div class="layout-right">
                    <div class="layout-nav">
                        <div class="menu-item" :class="{active:currentMenuIndex==index}" v-for="(item,index) in menuList" :key="index" @click="selectMenuItem(index,item)">
                            <i class="icon" :class="[item.icon,{active:currentMenuIndex==index}]" ></i>
                            {{item.name}}
                        </div>
                    </div>
                    <div class="control-bar">
                        <div v-if="!token">
                            <a  href="javascript:void(0)" @click="openModal('login')" class="login" >登录</a>
                            <span class="line">|</span>
                            <a  class="login"  href="javascript:void(0)" @click="openModal('register')">注册</a>
                        </div>
                        <div v-else class="header-wrap">
                            <img class='head-img-url' v-if="userInfo.headImgUrl" :src="userInfo.headImgUrl" alt="">
                            <Dropdown @on-click="openModal('fx')">
                                <a class="nick-name" href="javascript:void(0)"  @click="toPath('personCenter')">
                                    {{userInfo.nickName}}
                                    <!--<Icon type="ios-arrow-down"></Icon>-->
                                </a>
                                <!--<DropdownMenu style="background-color: #000"   slot="list">-->
                                <!--<DropdownItem >退出</DropdownItem>-->
                                <!--</DropdownMenu>-->
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </Menu>
        </Header>
        <login-modal ref="login"   @toRegister="openModal('register')" @toResetPwd="openModal('resetPwd')" @closeModal="closeModal('login')" ></login-modal>
        <register-modal ref="register" @toLogin="openModal('login')" @closeModal="closeModal('register')" ></register-modal>
        <reset-pwd-modal ref="resetPwd"  @toLogin="openModal('login')" @closeModal="closeModal('resetPwd')" ></reset-pwd-modal>
        <fx-modal ref="fx"  :title="plugin.modal.fx.title" @closeModal="closeModal('fx')" :contentText="plugin.modal.fx.desc" @ok="toLogout" ></fx-modal>
    </div>
</template>

<script>
    var self;
    import  loginModal from './loginModal'
    import  registerModal from './registerModal'
    import  resetPwdModal from './resetPwdModal'
    import  fxModal from '../fx-modal'
    import {mapState,mapActions,mapMutations} from 'vuex'
    export default {
        name: "commonHeader",
        components:{
            loginModal,
            registerModal,
            resetPwdModal,
            fxModal
        },
        computed: {
            ...mapState(['token','userInfo','currentMenuIndex']),
        },
        mounted(){
            self = this;
            // console.log('userInfo',this.userInfo)
            // setTimeout(function () {
            //     self.changeDropDownStyle()
            // },200)
        },
        data:()=>{
            return{
                menuList:[{
                    key:'Home',
                    name:'首页',
                    icon:'home'
                },{
                    key:'services',
                    name:'海葬服务',
                    icon:'sea'
                },{
                    key:'memorial',
                    name:'纪念馆',
                    icon:'heart'
                },{
                    key:'news',
                    name:'新闻中心',
                    icon:'news'
                },
                {
                    key:'order/order',
                    name:'海葬预约',
                    icon:'order'
                },
                {
                    key:'about',
                    name:'联系我们',
                    icon:'contact'
                }],
                plugin:{
                    modal:{
                        login:{
                            fade:false,
                            title:'登录'
                        },
                        register:{
                            fade:false,
                            title:'注册'
                        },
                        resetPwd:{
                            fade:false,
                            title:'重置密码'
                        },
                        fx:{
                            fade:false,
                            title:'退出登录?',
                            desc:'是否退出登录？'
                        }
                    }
                }
            }
        },
        methods:{
            ...mapActions(['logout']),
            ...mapMutations(['setCurrentMenuIndex']),
            // changeDropDownStyle(){
            //     var elemnet = document.documentElement.getElementsByClassName('ivu-select-dropdown')
            //     if(elemnet.length){
            //         elemnet[0].style.backgroundColor = '#333'
            //     }
            // },
            closeModalAll(){
                for(let i in this.$refs){
                    setTimeout(function () {
                        self.$refs[i].hide()
                    },80)
                }
            },
            closeModal(key){
                console.log('closeModal,',key)
                // this.plugin.modal[key].fade = false
                this.$refs[key].hide()
            },
            openModal(key){
                this.closeModalAll()
                // console.log('openModal,',key)
                // this.plugin.modal[key].fade = true
                setTimeout(function () {
                    self.$refs[key].open()
                },300)
            },
            selectMenuItem ( index,item ) {
                if(!item.key)return
                this.setCurrentMenuIndex(index)
                this.toPath(item.key)
            },
            toPath(key){
                // console.log('toPath',key)
                this.$router.push({
                    path: `/${key}/`
                })
            },
            toLogout(){
                // console.log('logout')
                this.logout()
                this.$router.push({
                    path: `/home/`
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .ivu-select-dropdown{
        li.ivu-dropdown-item{
            background-color: #333;
            color: #fff;
        }
    }
    .ivu-layout-header{
        background-color: #333;
    }
    .header-wrap{
        &:hover{
            cursor: pointer;
        }
    }
    .header-menu{
        max-width: 1170px;
        margin: 0 auto;
        background: transparent;
    }
    .layout-logo {
        margin-top: 8px;
        float: left;
        position: relative;
        width: 175px;
        height: 45px;
        background: url('../../assets/images/icon/logo.jpg') no-repeat ;
    }
    .layout-right{
        float: right;
        overflow: hidden;
        .layout-nav {
            float: left;
            width: 610px;
            display: inline-block;
            margin-right: 20px;
            overflow: hidden;
            .menu-item{
                color:#fff ;
                float: left;
                width: 16%; /* 如果加海葬预约 16% */
                i.icon{
                    width: 16px;
                    height: 16px;
                    display: inline-block;
                    background-size: contain;
                    background-repeat: no-repeat;
                    vertical-align: sub;
                    &.home{
                        background-image: url('../../assets/images/icon/home.png');
                    }
                    &.sea{
                        background-image: url('../../assets/images/icon/sea.png');
                    }
                    &.heart{
                        background-image: url('../../assets/images/icon/heart.png');
                    }
                    &.news{
                        background-image: url('../../assets/images/icon/news.png');
                    }
                    &.order {
                        background-image: url("../../assets/images/icon/order.png");
                    }
                    &.contact{
                        background-image: url('../../assets/images/icon/contact.png');
                    }
                }
                &:hover , &.active{
                    color:#2d8cf0;
                    cursor: pointer;
                    i.icon{
                        &.home{
                            background-image: url('../../assets/images/icon/home_active.png');
                        }
                        &.sea{
                            background-image: url('../../assets/images/icon/sea_active.png');
                        }
                        &.heart{
                            background-image: url('../../assets/images/icon/heart_active.png');
                        }
                        &.news{
                            background-image: url('../../assets/images/icon/news_active.png');
                        }
                        &.order {
                            background-image: url("../../assets/images/icon/order_active.png");
                        }
                        &.contact{
                            background-image: url('../../assets/images/icon/contact_active.png');
                        }
                    }
                }
            }
            @media (max-width: 1100px){
                width: 520px;
            }
        }
        .control-bar{
            min-width: 50px;
            float: right;
            padding-left: 3px;
            font-size: 12px;
            font-weight: 600;
            color: #fff;
            position:relative;
            a.nick-name{
                color: #fff;
                padding: 0 3px;
            }
            .header-wrap{
                padding-left: 40px;
                .head-img-url{
                    width: 30px;
                    height: 30px;
                    overflow: hidden;
                    border-radius: 50%;
                    position: absolute;
                    left: 10px;
                    top: 13px;
                }
            }
        }
    }
    .line{
        padding: 0 5px;
    }

</style>
